import React from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { format } from "date-fns";
var getTourTypeLabel = function (tourType) {
    var labels = {
        "0": "Guided Tour",
        "1": "Self-Guided Tour",
        "2": "Live Video Tour",
        "3": "Virtual Tour",
    };
    return labels[tourType] || "Tour";
};
export var StepConfirmation = function (_a) {
    var formData = _a.formData, appointmentId = _a.appointmentId, prospectId = _a.prospectId, isApptCanceled = _a.isApptCanceled, successMessage = _a.successMessage, onDebugCancelApt = _a.onDebugCancelApt, onReset = _a.onReset;
    return (React.createElement("div", { className: "flex flex-col items-center text-center" },
        React.createElement(CheckCircle2, { className: "h-16 w-16 text-green-500 mb-4" }),
        React.createElement("h2", { className: "text-2xl font-bold mb-2" }, "Tour Booked Successfully!"),
        React.createElement("p", { className: "text-muted-foreground mb-6" }, successMessage),
        React.createElement("div", { className: "bg-muted/50 rounded-lg p-6 w-full max-w-md text-left space-y-3" },
            React.createElement("div", null,
                React.createElement("p", { className: "text-sm text-muted-foreground" }, "Date"),
                React.createElement("p", { className: "font-semibold" }, formData.appointmentDate
                    ? format(formData.appointmentDate, "EEEE, MMMM d, yyyy")
                    : "Not selected")),
            React.createElement("div", null,
                React.createElement("p", { className: "text-sm text-muted-foreground" }, "Time"),
                React.createElement("p", { className: "font-semibold" }, formData.appointmentTime)),
            React.createElement("div", null,
                React.createElement("p", { className: "text-sm text-muted-foreground" }, "Tour Type"),
                React.createElement("p", { className: "font-semibold" }, getTourTypeLabel(formData.tourType))),
            React.createElement("div", null,
                React.createElement("p", { className: "text-sm text-muted-foreground" }, "Contact"),
                React.createElement("p", { className: "font-semibold" },
                    formData.firstName,
                    " ",
                    formData.lastName),
                React.createElement("p", { className: "text-sm" }, formData.email),
                formData.phone && React.createElement("p", { className: "text-sm" }, formData.phone))),
        React.createElement(Button, { onClick: onReset, className: "mt-8", size: "lg" }, "Book Another Tour"),
        React.createElement("div", { className: "mt-8 w-full max-w-md" },
            React.createElement("div", { className: "bg-gray-900/95 border border-gray-800 rounded-xl px-5 py-4 mb-4 shadow-md" },
                React.createElement("p", { className: "text-xs uppercase font-bold tracking-wide text-gray-300 mb-2" }, "Debug Panel"),
                appointmentId && prospectId && (React.createElement("div", { className: "flex flex-col space-y-2" },
                    React.createElement("div", { className: "flex items-center justify-between" },
                        React.createElement("span", { className: "text-sm text-gray-400" }, "Appointment ID:"),
                        React.createElement("span", { className: "font-mono text-gray-200 font-semibold" }, appointmentId)),
                    React.createElement("div", { className: "flex items-center justify-between" },
                        React.createElement("span", { className: "text-sm text-gray-400" }, "Prospect ID:"),
                        React.createElement("span", { className: "font-mono text-gray-200 font-semibold" }, prospectId)))),
                React.createElement("div", { className: "mt-4 flex justify-end" },
                    React.createElement(Button, { variant: "destructive", onClick: onDebugCancelApt, size: "sm" }, "Cancel Appointment")),
                isApptCanceled && (React.createElement("div", { className: "bg-green-100 border border-green-300 mt-4 p-2 rounded text-green-800 text-sm transition-all" },
                    React.createElement("p", null, "Appointment canceled successfully")))))));
};
